import React from "react";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import NativeSelect from "@material-ui/core/NativeSelect";
import dayjs from "dayjs";
const math = require("mathjs");

const calculateAverage = (scores) => {
  let arr = [];
  for (let i = 0; i < scores.length; i += 2) {
    if (scores[i] !== null) {
      arr.push(math.sum([scores[i], scores[i + 1]].filter((x) => x != null)));
    }
  }
  return arr.length > 0 ? math.mean(arr) : null;
};

export default class AssessmentTable extends React.Component {
  levelSelector = (a) => {
    if (a.level !== null) {
      return a.level;
    } else {
      return (
        <NativeSelect
          value={a.level != null ? a.level : ""}
          onChange={(e) => this.props.handleLevelSelect({ e, a })}
          inputProps={{
            name: "level",
            id: "level-native-helper",
          }}
        >
          <option aria-label="Select a Level" value="" />
          {[1, 2, 3, 4, 5].map((x) => (
            <option value={x} key={a.name + "level" + x}>
              {x}
            </option>
          ))}
        </NativeSelect>
      );
    }
  };

  avgScores = (domain, a) => {
    const scores = a.domains[domain] ? a.domains[domain].scores : [];
    const f = calculateAverage(scores);

    if (f !== null && f !== "") {
      return (
        <Button
          size="small"
          color="primary"
          onClick={() => this.props.handleEditClickOpen({ domain, a })}
        >
          {f.toFixed(2)}
        </Button>
      );
    } else if (a.level !== null) {
      return (
        <IconButton
          color="primary"
          aria-label="Add Assessment"
          onClick={() => this.props.handleEditClickOpen({ domain, a })}
        >
          <EditIcon style={{ fontSize: 24 }} />
        </IconButton>
      );
    }
  };

  render() {
    return (
      <Grid container spacing={0}>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Student</TableCell>
                <TableCell>Teacher</TableCell>
                <TableCell>Level</TableCell>
                <TableCell>Created</TableCell>
                <TableCell align="right">Numbers and Operations</TableCell>
                <TableCell align="right">Algebra</TableCell>
                <TableCell align="right">Geometry</TableCell>
                <TableCell align="right">Measurement</TableCell>
                <TableCell align="right">DAP</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.assessments.map((a) => (
                <TableRow key={a.assessmentId}>
                  <TableCell component="th" scope="row">
                    <Button
                      size="small"
                      color="primary"
                      onClick={() => this.props.handleViewOpen({ a })}
                    >
                      {a.student}
                    </Button>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {a.teacher}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {this.levelSelector(a)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {dayjs.unix(a.date._seconds).fromNow()}
                  </TableCell>
                  <TableCell align="right">
                    {this.avgScores("numops", a)}
                  </TableCell>
                  <TableCell align="right">
                    {this.avgScores("algebra", a)}
                  </TableCell>
                  <TableCell align="right">
                    {this.avgScores("geometry", a)}
                  </TableCell>
                  <TableCell align="right">
                    {this.avgScores("measurement", a)}
                  </TableCell>
                  <TableCell align="right">
                    {this.avgScores("dap", a)}
                  </TableCell>
                  <TableCell align="right">
                    <Button
                      size="small"
                      color="primary"
                      onClick={() => this.props.deleteAssessmentHandler({ a })}
                    >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    );
  }
}
